import React, { FC } from 'react';
import { Box, DataTable } from '@scope/scope-one-ui/core';
import { ModalProps } from '@scope/scope-one-ui/core/Modal/Modal.d';
import { useTranslation } from 'react-i18next';
import content from './content.json';
import { Dot, Modal } from './MoreInfoModal.styled';

export const MoreInfoModal: FC<ModalProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Modal {...props} size="medium" title={t('ESG Sentiment definitions')} cancelLabel={t('Close')}>
      <Box p={2}>
        <DataTable
          stickyHeader
          maxHeight={70}
          cols={[
            {
              name: 'term',
              label: t('Term'),
              customBodyRender: (text) => (
                <Box display="flex" gridGap={1.5} alignItems="center">
                  <Dot />
                  {text}
                </Box>
              ),
            },
            { name: 'definition', label: t('Definition') },
          ]}
          rows={content.map((data, id) => ({
            id: `${id}`,
            data: {
              term: t(data.term),
              definition: t(data.definition),
            },
          }))}
        />
      </Box>
    </Modal>
  );
};
